import { matchPath, useNavigation } from 'react-router'

/**
 * The ID of the job a pending navigation is heading to, if any. The router
 * keeps rendering the current job until the next one's loader resolves.
 */
export function usePendingJobId() {
  const navigation = useNavigation()

  return navigation.location
    ? matchPath('/jobs/:jobId', navigation.location.pathname)?.params.jobId
    : undefined
}
